export default {
  name: 'pieWidget1',
  globals: {
    variables: {
      since: 'now-1h',
      until: 'now',
    },
  },
  spec: {
    datasources: {
      countsByInstanceType: {
        type: 'uql',
        options: {
          since: '/${ globals.variables.since }',
          until: '/${ globals.variables.until }',
          propsRef: '/${ props }',
          fetch: 'FETCH attributes(cloud.host.type), count',
          from: 'FROM entities(aws:ec2)',
          filters: [],
          filterStr:
            "${ $count([$filter(filters, $boolean)]) > 0 ? '[' & $join([$filter(filters, $boolean)], ' && ') & ']' : '' }",
          queryStr: "${ $join([from, filterStr, fetch], ' ') }",
        },
      },
    },
    view: [
      [
        'dashify:CardWithTitle',
        { title: 'EC2 Instances By Type' },
        [
          [
            'dashify:Pie',
            {
              highchartsConfig: {
                height: '/${ props.height }',
                title: {
                  text: '/${ data.countsByInstanceType.data ? $sum(data.countsByInstanceType.data.count) : 0 }',
                },
                chart: {
                  backgroundColor: '/${ props.chart.backgroundColor }',
                  plotBackgroundColor: '/${ props.chart.backgroundColor }',
                },
                plotOptions: {
                  pie: {
                    size: 160,
                    dataLabels: {
                      enabled: true,
                    },
                  },
                },
                series: [
                  {
                    name: 'Type',
                    data: "/${ $sort(data.countsByInstanceType.data.{'name': cloud_host_type, 'y': count}, function($l, $r) { $l.y < $r.y}) }",
                  },
                ],
              },
            },
          ],
        ],
      ],
    ],
  },
};
